/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ImageSizeSmall({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M1.4 2a.6.6 0 0 1 .6-.6h12a.6.6 0 1 1 0 1.2H2a.6.6 0 0 1-.6-.6ZM1.4 14a.6.6 0 0 1 .6-.6h12a.6.6 0 0 1 0 1.2H2a.6.6 0 0 1-.6-.6ZM2 9.4a.6.6 0 1 0 0 1.2h2a.6.6 0 1 0 0-1.2H2ZM11.4 10a.6.6 0 0 1 .6-.6h2a.6.6 0 1 1 0 1.2h-2a.6.6 0 0 1-.6-.6ZM2 5.4a.6.6 0 0 0 0 1.2h2a.6.6 0 1 0 0-1.2H2ZM11.4 6a.6.6 0 0 1 .6-.6h2a.6.6 0 1 1 0 1.2h-2a.6.6 0 0 1-.6-.6Z" /><path fill="currentColor" fillRule="evenodd" d="M7.25 4.9a1.6 1.6 0 0 0-1.6 1.6v3a1.6 1.6 0 0 0 1.6 1.6h1.5a1.6 1.6 0 0 0 1.6-1.6v-3a1.6 1.6 0 0 0-1.6-1.6h-1.5Zm-.4 1.6c0-.22.18-.4.4-.4h1.5c.22 0 .4.18.4.4v3a.4.4 0 0 1-.4.4h-1.5a.4.4 0 0 1-.4-.4v-3Z" clipRule="evenodd" /></svg>;
}
;